// @flow
import { observer } from 'mobx-react';
import React, { Fragment } from 'react';
import copy from 'copy-to-clipboard';
import Refresh from 'material-react-icons/Refresh';
import t from '~/src/services/i18n';
import Code from '~/src/components/Code';
import Filter_none from 'material-react-icons/FilterNone';
import trackEvent from '~/src/services/analytics';
import './CodePanel.scss';

type Props = {
  code: string,
  resetForm: Function,
}

const CodePanel = observer((props: Props) => {
  const { code, resetForm, codeConfigOnly, setCodeConfigOnly } = props;

  return (
    <Fragment>
      {codeConfigOnly && (
        <div className="config-type-message">
          {t('Use this code within Cloudinary eCommerce integrations. For the full JS code')} <a onClick={() => setCodeConfigOnly(false)}>{t('click here')}</a>
        </div>
      )}
      {codeConfigOnly === false && (
        <div className="config-type-message">
          {t('For the config only JS code')} <a onClick={() => setCodeConfigOnly(true)}>{t('click here')}</a>
        </div>
      )}
      <Code>{props.code}</Code>
      <div className="action-bar">
        <button
          className="btn btn-primary btn-small btn-icon reset-btn"
          onClick={resetForm}
        >
          <Refresh />
          {t('resetDemo')}
        </button>
        <button
          className="btn btn-primary btn-small btn-icon copy-btn"
          onClick={() => {
            copy(code);
            trackEvent({ action: 'copy to clipboard', label: 'copy gallery widget configuration to clipboard' });
            window.alert('Copied code to clipboard');
          }}
        >
          <Filter_none className="clipboard-icon" />
          {t('copyToClipBoard')}
        </button>
      </div>
    </Fragment>
  );
});

export default CodePanel;
